export const ADDITIONAL_PRODUCTS_STEP = 'additional'
export const SUMMARY_STEP = 'summary'
export const DELIVERY_STEP = 'delivery'
export const PAYMENT_STEP = 'payment'

export const PLACE_PICKUP_DELIVERY_STEP = 'delivery-pickup-place'
export const TIME_PICKUP_DELIVERY_STEP = 'delivery-pickup-time'
export const PLACE_COURIER_DELIVERY_STEP = 'delivery-courier-place'
export const TIME_COURIER_DELIVERY_STEP = 'delivery-courier-time'
export const ADDRESS_COURIER_DELIVERY_STEP = 'delivery-courier-address'
export const ADDRESS_PICKUP_DELIVERY_STEP = 'delivery-pickup-address'

export const thumb = {
  square: { w: 125, h: 125, fit: 'fill', fm: 'webp' },
}
